<template>
    <div class="columns" :class="`columns-num-${data.cols.length}`">
        <body-renderer
            v-for="(column, i) in data.cols"
            :key="i"
            class="article-body column"
            :blocks="column.blocks"
            :variant="variant"
            :title="title"
        />
    </div>
</template>

<script setup lang="ts">
import type { BodyVariant, ColumnsData } from '@model/editor-js/blocks';
import BodyRenderer from '../body-renderer.vue';

defineOptions({
    name: 'BlockColumns',
});

defineProps<{
    id?: string;
    data: ColumnsData;
    variant: BodyVariant;
    title?: string;
}>();
</script>

<style lang="pcss" scoped>
.body-renderer .columns {
    column-gap: 24px;
}

@media (--viewport-tablet) {
    .body-renderer .columns-num-2 {
        column-count: 2;
    }

    .body-renderer .columns-num-3 {
        column-count: 3;
    }
}

.body-renderer .column {
    /* disable margin collapse to avoid uneven vertical alignment */
    border: 1px solid transparent;

    /* disable columns boundary crossing */
    break-inside: avoid;
}
</style>
